import {combineReducers} from 'redux';

function logged(state = false, action) {
  switch (action.type) {
    case 'USER_STATE_ERROR':
    case 'USER_STATE_REQUEST':
      return false;
    case 'USER_STATE_SUCCESS':
      return true;
    default:
      return state;
  }
}

export default combineReducers({
  logged
});



// WEBPACK FOOTER //
// ./reducers/user.js